import axios from 'axios'
import qs from 'qs'
import rootApi from '@/rootUrl'
const root = rootApi //接口API
// const root = "https://stuapi.kidcastle.cn"
const url = {
  getMaps: `${root}/Goover/getMaps`,
  getMapsResource: `${root}/Goover/getMapsResource`,
  getMapsSteps: `${root}/Goover/getMapsSteps`,
  getMapsStepsMedias: `${root}/Goover/getMapsStepsMedias`,
  saveStepsLog: `${root}/Goover/saveStepsLog`, // 提交闯关结果
  SubmitTask: `${root}/Stutask/SubmitTask`, // 任务中心->提交完成学生任务
}
const mp3Store = {
  getMaps(params: any) {
    return axios.get(url.getMaps, { params })
  },
  getMapsResource(params: any) {
    return axios.get(url.getMapsResource, { params })
  },
  getMapsSteps(params: any) {
    return axios.get(url.getMapsSteps, { params })
  },
  getMapsStepsMedias(params: any) {
    return axios.get(url.getMapsStepsMedias, { params })
  },
  saveStepsLog(params: any) {
    return axios.post(url.saveStepsLog, qs.stringify(params))
  },
  SubmitTask(params: any) {
    return axios.post(url.SubmitTask, qs.stringify(params))
  },
}

export default mp3Store;